/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const loyaltyEnumSchema = z.enum([
	"MCRM",
	"IIKO",
	"PRIME_HILL",
	"PREMIUM_BONUS",
	"LOONA_AI",
	"MINDBOX",
	"SWIP",
	"SAILPLAY",
	"REMARKED",
	"LOYALTY_PLANT",
	"TEYCA",
	"FOOD_PICASSO",
	"UDS",
	"LOCARDS",
	"MAXMA",
]);
